// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gUpf","questions":"styles_questions__22W42","footer":"styles_footer__2Hmsv"};